<template>
  <!-- 注册须知 -->
  <div>
    <el-dialog
      :visible="value"
      width="800px"
      append-to-body
      :close-on-click-modal="false"
      style="margin:0 auto"
      :show-close="false"
    >
      <div slot="title" class="fz20 c_1A1A1A font_w_bold">{{ title }}</div>

      <div class="register_read_w">
        <div class="read_content fz14" v-html="content" />
      </div>

      <span slot="footer" class="">
        <el-button class="button_4" @click="onCancalClick">取消</el-button>
        <el-button class="button_3" @click="onAgreeRead">同意并继续</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },

    content: String,
    title: String
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {
    // 同意注册须知
    onAgreeRead() {
      this.$emit('onConfirm')
    },
    // 取消 click
    onCancalClick() {
      this.$emit('onCancal', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.read_content {
  overflow: auto;
  max-height: 480px;
  text-indent: 30px;
  line-height: 24px;
  padding: 20px;
}
::v-deep .el-dialog__header {
  padding: 23px 40px;
  background-color: #f2f2f2;
}
::v-deep .el-dialog__body {
  padding: 0 0 0 20px;
}
::v-deep .el-dialog__footer {
  padding: 21px;
  text-align: center;
  background-color: #f2f2f2;
  .button_3,
  .button_4 {
    padding-left: 30px;
    padding-right: 30px;
  }
  .button_3 {
     background-color: #0983cc;
    color: #fff;
    &:hover,
    &:focus {
      background-color: #0983cc;
      color: #fff;
    }
  }
  .button_4 {
    &:hover,
    &:focus {
      background-color: #fff;
      color: #1a1a1a;
    }
    &:active {
      border: 1px solid #c6e2ff;
    }
  }
}
</style>
